<template>
  <SoDataTable
    :headers="headers"
    :items="items"
    :searchable="false"
    :has-pagination="false"
    select-key="name"
    no-data-text="No alerts"
    data-testid="alerts-table"
  >
    <template #[`item.position`]="{ internalItem }">
      <span class="font-weight-bold" data-testid="alert-position">
        {{ asAlert(internalItem.raw).position }}
      </span>
      <SoChip
        v-if="!asAlert(internalItem.raw).inPriorityList"
        text="not in list"
        size="x-small"
        class="ml-1"
        data-testid="alert-not-in-list"
      />
    </template>
    <template #[`item.severity`]="{ internalItem }">
      <SoChip
        :type="severityChipType(asAlert(internalItem.raw).severity)"
        :text="asAlert(internalItem.raw).severity"
        size="small"
        data-testid="alert-severity"
      />
    </template>
    <template #[`item.alert`]="{ internalItem }">
      <div class="py-2 alert-cell">
        <div class="font-weight-bold" data-testid="alert-title">
          {{ asAlert(internalItem.raw).title }}
        </div>
        <div class="text-body-2">{{ asAlert(internalItem.raw).body }}</div>
      </div>
    </template>
    <template #[`item.isDismissible`]="{ internalItem }">
      <span data-testid="alert-dismissible">
        {{ asAlert(internalItem.raw).isDismissible ? "Yes" : "No" }}
      </span>
    </template>
    <template #[`item.tags`]="{ internalItem }">
      {{ asAlert(internalItem.raw).tags.join(", ") }}
    </template>
    <template #[`item.name`]="{ internalItem }">
      <code class="text-caption">{{ asAlert(internalItem.raw).name }}</code>
    </template>
  </SoDataTable>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDataTable from "@/components/dataTable/SoDataTable.vue"
  import SoChip from "@/components/SoChip.vue"
  import { SoChipType } from "@/types/components/SoChip"
  import {
    SoDataTableHeader,
    SoDataTableItem,
  } from "@/types/components/SoDataTable"
  import { IAlertDefinition } from "@/models/alertsBanners/alertsBanners.types"

  const headers: SoDataTableHeader[] = [
    { key: "position", title: "#", sortable: false },
    { key: "severity", title: "Severity", sortable: false },
    { key: "alert", title: "Alert", sortable: false },
    { key: "isDismissible", title: "Dismissible", sortable: false },
    { key: "tags", title: "Tags", sortable: false },
    { key: "name", title: "Name", sortable: false },
  ]

  export default defineComponent({
    components: { SoDataTable, SoChip },
    props: {
      alerts: {
        type: Array as PropType<IAlertDefinition[]>,
        required: true,
      },
    },
    data() {
      return { headers }
    },
    computed: {
      // SoDataTable types its rows loosely; each one is an IAlertDefinition.
      items(): SoDataTableItem[] {
        return this.alerts as unknown as SoDataTableItem[]
      },
    },
    methods: {
      asAlert(raw: unknown): IAlertDefinition {
        return raw as IAlertDefinition
      },
      severityChipType(severity: string): SoChipType {
        const s = severity.toUpperCase()
        if (s === "ERROR" || s === "CRITICAL") return SoChipType.ERROR
        if (s === "WARNING") return SoChipType.WARNING
        if (s === "SUCCESS") return SoChipType.SUCCESS
        return SoChipType.DEFAULT
      },
    },
  })
</script>
<style scoped>
  .alert-cell {
    min-width: 240px;
    max-width: 480px;
  }
</style>
